/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Scene_DescriptionsInputs */



/**
* | output |
* | --- |
* | "Automatic Shot Descriptions" |
*
* @param {Automatic_Scene_DescriptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_scene_descriptions = /** @type {((inputs?: Automatic_Scene_DescriptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Scene_DescriptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Descriptions automatiques des prises de vue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Schussbeschreibungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizioni automatiche delle inquadrature")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание автоматических выстрелов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripciones de tomas automáticas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动拍摄描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動撮影の説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित शॉट विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrições automáticas de disparos")
	return /** @type {LocalizedString} */ ("Automatic Shot Descriptions")
});